import _extends from '@babel/runtime-corejs3/helpers/extends';
import _defineProperty from '@babel/runtime-corejs3/helpers/defineProperty';
import _toConsumableArray from '@babel/runtime-corejs3/helpers/toConsumableArray';
import _slicedToArray from '@babel/runtime-corejs3/helpers/slicedToArray';
import _concatInstanceProperty from '@babel/runtime-corejs3/core-js-stable/instance/concat';
import _Object$keys from '@babel/runtime-corejs3/core-js-stable/object/keys';
import _Object$getOwnPropertySymbols from '@babel/runtime-corejs3/core-js-stable/object/get-own-property-symbols';
import _filterInstanceProperty from '@babel/runtime-corejs3/core-js-stable/instance/filter';
import _Object$getOwnPropertyDescriptor from '@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptor';
import _forEachInstanceProperty from '@babel/runtime-corejs3/core-js-stable/instance/for-each';
import _Object$getOwnPropertyDescriptors from '@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptors';
import _Object$defineProperties from '@babel/runtime-corejs3/core-js-stable/object/define-properties';
import _Object$defineProperty from '@babel/runtime-corejs3/core-js-stable/object/define-property';
import React__default, { useEffect, useState, useCallback, useMemo } from 'react';
import { usePopper as usePopper$1 } from 'react-popper';
import { bottom } from '@popperjs/core';
import ReactFocusLock from 'react-focus-lock';
import './32d3a30a5d74a13ae8d6fca05d79c88543ab5fcf5d78a932090070ca167dafaf.cfe-internal.js';
import '../Portal/b81e2c2574be9c22ca169f92e296afd0d628545ddf948842d62ee3855f5f7353.cfe-internal.js';
import '../mergeRefs/78d5bc4c67d8d58f9c10e9410225355915c50badf967bc3a0d22a094587a8377.cfe-internal.js';
import usePopperContext, { PopperContextProvider } from './02d5306d2fca5139dccb7b44903929488827f165b0cea69ac2910ae5d985e332.cfe-internal.js';
import mergeRefs from '../mergeRefs/836dcb860bec00d9c59bd64df8df6df42430840bc5bfc21b6000935baefbeacd.cfe-internal.js';
import Portal from '../Portal/021a1fdc9ca1735be9937767b2058e59614ca8e92028492bbc50e54e37b552ec.cfe-internal.js';

var _process$env;
function ownKeys(e, r) { var t = _Object$keys(e); if (_Object$getOwnPropertySymbols) { var o = _Object$getOwnPropertySymbols(e); r && (o = _filterInstanceProperty(o).call(o, function (r) { return _Object$getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var _context2, _context3; var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? _forEachInstanceProperty(_context2 = ownKeys(Object(t), !0)).call(_context2, function (r) { _defineProperty(e, r, t[r]); }) : _Object$getOwnPropertyDescriptors ? _Object$defineProperties(e, _Object$getOwnPropertyDescriptors(t)) : _forEachInstanceProperty(_context3 = ownKeys(Object(t))).call(_context3, function (r) { _Object$defineProperty(e, r, _Object$getOwnPropertyDescriptor(t, r)); }); } return e; }
function useMockedPopper(_, popperElement, _ref) {
  var onFirstUpdate = _ref.onFirstUpdate;
  useEffect(function () {
    onFirstUpdate === null || onFirstUpdate === void 0 || onFirstUpdate();
  }, [onFirstUpdate, popperElement]);
  return {
    styles: {
      popper: {},
      arrow: {}
    },
    attributes: {
      popper: {}
    }
  };
}
var usePopper = typeof process !== 'undefined' && ((_process$env = process.env) === null || _process$env === void 0 ? void 0 : _process$env.NODE_ENV) === 'test' ? useMockedPopper : usePopper$1;
function useResizeObserver(_ref2) {
  var element = _ref2.element,
    handleResize = _ref2.handleResize,
    isDisabled = _ref2.isDisabled;
  useEffect(function () {
    if (typeof window.ResizeObserver !== 'undefined' && element && !isDisabled) {
      // eslint-disable-next-line compat/compat
      var resizeObserver = new ResizeObserver(handleResize);
      resizeObserver.observe(element);
      return function () {
        resizeObserver.disconnect();
      };
    }
  }, [handleResize, element, isDisabled]);
}
function useScroll(_ref3) {
  var element = _ref3.element,
    handleScroll = _ref3.handleScroll,
    isDisabled = _ref3.isDisabled;
  useEffect(function () {
    if (element && !isDisabled) {
      document.addEventListener('scroll', handleScroll, true); // useCapture needed since scroll events don't bubble to the document
      return function () {
        document.removeEventListener('scroll', handleScroll, true);
      };
    }
  }, [handleScroll, element, isDisabled]);
}
var Popper = function Popper(_ref4) {
  var _context;
  var _ref4$open = _ref4.open,
    open = _ref4$open === void 0 ? false : _ref4$open,
    _ref4$placement = _ref4.placement,
    placement = _ref4$placement === void 0 ? bottom : _ref4$placement,
    anchorElement = _ref4.anchor,
    popperElement = _ref4.popper,
    arrowElement = _ref4.arrow,
    externalAnchorNode = _ref4.anchorNode,
    portalTarget = _ref4.portalTarget,
    _ref4$modifiers = _ref4.modifiers,
    externalModifiers = _ref4$modifiers === void 0 ? [] : _ref4$modifiers,
    _ref4$isDisabled = _ref4.isDisabled,
    isDisabled = _ref4$isDisabled === void 0 ? false : _ref4$isDisabled,
    _ref4$isFocusLocked = _ref4.isFocusLocked,
    isFocusLocked = _ref4$isFocusLocked === void 0 ? false : _ref4$isFocusLocked,
    focusLockProps = _ref4.focusLockProps;
  var _useState = useState(externalAnchorNode),
    _useState2 = _slicedToArray(_useState, 2),
    anchorNode = _useState2[0],
    setAnchorNode = _useState2[1];
  var _useState3 = useState(),
    _useState4 = _slicedToArray(_useState3, 2),
    popperNode = _useState4[0],
    setPopperNode = _useState4[1];
  var _useState5 = useState(),
    _useState6 = _slicedToArray(_useState5, 2),
    arrowNode = _useState6[0],
    setArrowNode = _useState6[1];
  var _useState7 = useState(false),
    _useState8 = _slicedToArray(_useState7, 2),
    isReady = _useState8[0],
    setIsReady = _useState8[1];
  useEffect(function () {
    if (externalAnchorNode) {
      setAnchorNode(externalAnchorNode);
    }
  }, [externalAnchorNode]);
  useEffect(function () {
    if (!open) {
      setIsReady(false);
    }
  }, [open]);
  var modifiers = _concatInstanceProperty(_context = [{
    name: 'arrow',
    enabled: !!arrowNode,
    options: {
      element: arrowNode,
      padding: 6
    }
  }, {
    name: 'eventListeners',
    enabled: open && !isDisabled
  }, {
    name: 'computeStyles',
    options: {
      gpuAcceleration: false
    }
  }, {
    name: 'preventOverflow',
    options: {
      padding: 8
    }
  }]).call(_context, _toConsumableArray(externalModifiers));

  // Must be memoized to avoid infinite loop
  var onFirstUpdate = useCallback(function () {
    setIsReady(true);
  }, [setIsReady]);
  var _usePopper = usePopper(anchorNode, popperNode, {
      modifiers: modifiers,
      placement: placement,
      onFirstUpdate: onFirstUpdate
    }),
    styles = _usePopper.styles,
    attributes = _usePopper.attributes,
    update = _usePopper.update;
  var handleUpdate = useCallback(function () {
    update === null || update === void 0 || update();
  }, [update]);

  // Tell popper.js to update the positioning when the popper element changes size since it only listens for window resizing out of the box.
  // See CFE-1295
  useResizeObserver({
    element: popperNode,
    handleResize: handleUpdate,
    isDisabled: !isReady
  });

  // Tell popper.js to update the positioning when a scroll event occurs
  // Needed due to https://github.com/floating-ui/floating-ui/issues/1267. See CFE-843
  useScroll({
    element: popperNode,
    handleScroll: handleUpdate,
    isDisabled: !isReady
  });
  var _usePopperContext = usePopperContext(),
    isParentAnchorHidden = _usePopperContext.isParentAnchorHidden;

  /*
   * If the parent anchor is hidden via CSS opacity, Popper will not consider it to be hidden.
   * To get around this issue, we set `data-popper-reference-hidden` to `true` for all child Popper elements if any ancestor Popper has `data-popper-reference-hidden` set to `true`.
   */
  var isAnchorHidden = useMemo(function () {
    var _attributes$popper;
    return isParentAnchorHidden || !!(attributes !== null && attributes !== void 0 && (_attributes$popper = attributes.popper) !== null && _attributes$popper !== void 0 && _attributes$popper['data-popper-reference-hidden']);
  }, [isParentAnchorHidden, attributes]);
  var context = useMemo(function () {
    return {
      isParentAnchorHidden: isAnchorHidden
    };
  }, [isAnchorHidden]);
  var popperElementWithArrow = /*#__PURE__*/React__default.cloneElement(popperElement, _objectSpread(_objectSpread({
    ref: mergeRefs(setPopperNode, popperElement.ref),
    style: _objectSpread(_objectSpread({}, styles.popper), popperElement.props.style)
  }, attributes.popper), {}, {
    'data-popper-reference-hidden': isAnchorHidden,
    'data-popper-ready': isReady,
    children: arrowElement ? [popperElement.props.children, /*#__PURE__*/React__default.cloneElement(arrowElement, {
      key: 'arrow',
      'aria-hidden': true,
      ref: mergeRefs(setArrowNode, arrowElement.ref),
      style: _objectSpread(_objectSpread({}, styles.arrow), arrowElement.props.style)
    })] : popperElement.props.children
  }));
  return /*#__PURE__*/React__default.createElement(React__default.Fragment, null, anchorElement && /*#__PURE__*/React__default.cloneElement(anchorElement, {
    ref: mergeRefs(setAnchorNode, anchorElement.ref)
  }), /*#__PURE__*/React__default.createElement(PopperContextProvider, {
    value: context
  }, /*#__PURE__*/React__default.createElement(Portal, {
    portalTarget: portalTarget
  }, open ? isFocusLocked ? /*#__PURE__*/React__default.createElement(ReactFocusLock, _extends({}, focusLockProps, {
    disabled: isReady ? focusLockProps === null || focusLockProps === void 0 ? void 0 : focusLockProps.disabled : true // Prevents unintended page scroll when popper element is not yet positioned
  }), popperElementWithArrow) : popperElementWithArrow : null)));
};

export { Popper as default };
